import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { IconButton, Tooltip, Chip } from '@mui/material';
import { AccordionItem } from 'react-accessible-accordion';
import { DataObject as DataIcon } from '@mui/icons-material';

import './activities.css';
import SMS from './SMS.js';
import Note from './Note.js';
import Call from './Call.js';
import Task from './Task.js';
import Email from './Email.js';
import Meeting from './Meeting.js';
import Comments from './props/Comments.js';
import { updateActivity } from '../../../store/Activities/index';
import { setSinglePageData } from '../../../store/SinglePage/index';
import DataViewerModal from '../../../components/Activities/DataViewerModal';

const ActivityCard = (props) => {
   const dispatch = useDispatch();

   let { singlePageData, activity, index, group } = props;
   let { createdBy, assignedTo, createdAt, dueDate, type } = activity;

   const [updateObject, setUpdateObject] = useState({ _id: activity['_id'], group, objectType: singlePageData['objectType'], objectId: singlePageData['_id'] });
   const [dataModalOpen, setDataModalOpen] = useState(false);

   // Update the updateObject when activity changes (important for newly created activities)
   useEffect(() => {
      setUpdateObject({ _id: activity['_id'], group, objectType: singlePageData['objectType'], objectId: singlePageData['_id'] });
   }, [activity['_id'], group, singlePageData['objectType'], singlePageData['_id']]);

   let activityData = {
      dueDate: dueDate ? moment(dueDate).format('lll') : '',
      createdAt: createdAt ? moment(createdAt).format('lll') : '',
      createdBy: createdBy?.['firstName'] ? createdBy?.['firstName'] + ' ' + createdBy?.['lastName'] : createdBy?.['email'],
      assignedTo: assignedTo?.['firstName'] ? assignedTo?.['firstName'] + ' ' + assignedTo?.['lastName'] : assignedTo?.['email'],
   }

   const onUpdateActivity = (field, value) => {
      updateSinglePageReducer(field, value);

      // Previous code - direct mutation (caused issues with paste/save)
      // updateObject[field] = value;
      // setUpdateObject(updateObject);
      // dispatch(updateActivity(updateObject));

      // Create a new object to avoid mutation issues
      const newUpdateObject = { ...updateObject, [field]: value };
      setUpdateObject(newUpdateObject);
      dispatch(updateActivity(newUpdateObject));
   }

   // Update activity with multiple fields at once
   const onUpdateActivityMultiple = (updates) => {
      // Update reducer for each field
      Object.entries(updates).forEach(([field, value]) => {
         if (field !== 'attachments') { // Don't update attachments in reducer, they come from server
            updateSinglePageReducer(field, value);
         }
      });

      // Merge all updates into updateObject
      const newUpdateObject = { ...updateObject, ...updates };
      setUpdateObject(newUpdateObject);
      dispatch(updateActivity(newUpdateObject));
   }

   // Update this activity in the group and then update group into activitiesGrouped and then set activitiesGrouped into singlePageData
   const updateSinglePageReducer = (field, value) => {
      let newSinglePageData = { ...singlePageData };
      newSinglePageData['activities'] = newSinglePageData['activities'].map(act => act['_id'] == activity['_id'] ? { ...act, [field]: value } : act);
      newSinglePageData['activitiesGrouped'] = singlePageData['activitiesGrouped'].map(grp => grp['_id'] == group['_id'] ? { ...grp, activities: grp['activities'].map(act => act['_id'] == activity['_id'] ? { ...act, [field]: value } : act) } : grp);
      dispatch(setSinglePageData(newSinglePageData));
   }

   const showActivity = () => {
      const key = `a-${index}`;
      const props = {
         activity,
         activityData,
         onUpdateActivity,
         onUpdateActivityMultiple,
         hasExternalData: !!activity.data,
         dataSource: activity.dataSource,
         onViewData: () => setDataModalOpen(true)
      };

      switch (type) {
         case 'note':
            return <Note key={key} {...props} />;
         case 'task':
            return <Task key={key} {...props} />;
         case 'email':
            return <Email key={key} {...props} />;
         case 'call':
            return <Call key={key} {...props} />;
         case 'sms':
            return <SMS key={key} {...props} />;
         case 'meeting':
            return <Meeting key={key} {...props} />;
         default:
            // Fallback for unknown activity types
            return <Task key={key} {...props} />;
      }
   }

   return (
      <>
         <AccordionItem uuid={`a-${index}`}>
            {showActivity()}
            <div className="accordion-content comment-box"><Comments singlePageData={singlePageData} activityData={activityData} activity={activity} group={group} updateSinglePageReducer={updateSinglePageReducer} /></div>
         </AccordionItem>

         <DataViewerModal
            open={dataModalOpen}
            onClose={() => setDataModalOpen(false)}
            activity={activity}
         />
      </>
   );
};

export default ActivityCard;